import {
  createContext,
  useContext,
  useImperativeHandle,
  forwardRef,
  useCallback,
} from 'react';
import { Form, Button, FormInstance, FormProps } from 'antd';
import UnitItem from '@/components/UnitItem';
import { $fm } from '@/Intl';

interface FormCommonProps extends FormProps {
  onReset?: Func;
  defaults?: object; // 表单默认值
  onUpdate?: Func;
}

export interface FormCommonInstance extends FormInstance {
  updateValue: (arg: object) => void;
}

const FormContext = createContext<FormCommonInstance | null>(null);

const FormCommon = forwardRef<FormCommonInstance, FormCommonProps>(
  ({ children, onReset, defaults = {}, onUpdate, ...rest }, ref) => {
    const [form] = Form.useForm();

    const updateValue = useCallback(
      (arg: object) => {
        form.setFieldsValue(arg);
        onUpdate?.(arg);
      },
      [form, onUpdate],
    );

    /* 将form实例通过ref抛出去 */
    useImperativeHandle(ref, () => ({ ...form, updateValue }), [
      form,
      updateValue,
    ]);

    return (
      <Form
        form={form}
        onValuesChange={(_, values) => {
          onUpdate?.(values);
        }}
        {...rest}
      >
        {/* 将form实例通过context传递给FormItem */}
        <FormContext.Provider value={{ ...form, updateValue }}>
          {children}
        </FormContext.Provider>
        <UnitItem className='reset-btn-area'>
          <Button
            type='primary'
            onClick={() => {
              updateValue(defaults);
              onReset?.();
            }}
          >
            {$fm('RESET')}
          </Button>
        </UnitItem>
      </Form>
    );
  },
);

export const useFormCommon = () => {
  const form = useContext(FormContext);

  return form;
};

export default FormCommon;
